// @flow
import * as React from 'react';

import styled from 'styled-components';
import MUIButton from '@material-ui/core/Button';

type Props = {
  children?: React.Node,
};

const ButtonWrapper = styled(props => <MUIButton disableRipple {...props} />)`
  color: ${props => props.theme.palette.global01};
`;

const Button = ({ children, ...rest }: Props) => (
  <ButtonWrapper {...rest}>{children}</ButtonWrapper>
);

export default Button;



// WEBPACK FOOTER //
// /opt/build/repo/src/app/components/Button/Button.js